module.exports = __webpack_public_path__ + "static/media/wavemaker-350 2.f3147e62.svg";